import { createSlice } from '@reduxjs/toolkit';

const SucccessfullModifyDialogSlice = createSlice({
    name: 'SucccessfullModifyDialog',
    initialState: '',
    reducers: {
        setSuccessfullModifyDialog: (state, action) => {            
            return action.payload;
        }
    },
});

export const { setSuccessfullModifyDialog } = SucccessfullModifyDialogSlice.actions;
export default SucccessfullModifyDialogSlice.reducer;